import React from "react";
import PropTypes from "prop-types";
import { Modal } from "../../../../../components";

const SendNonRKPayInvoiceConfirmationModal = ({ show, onCancel, onSend, isEstimate }) => {
	const { lang } = global;

	return (
		<Modal
			show={show}
			onHide={onCancel}
			centered
		>
			<Modal.Header closeButton>
				<Modal.Title>{lang.t(isEstimate ? "Send Estimate" : "Send Invoice")}</Modal.Title>
			</Modal.Header>
			<Modal.Body>
				<div className="text-center">
					{lang.t(
						isEstimate
							? "You have unsaved changes on this estimate, would you like to save and proceed before sending?"
							: "You have unsaved changes and invoices cannot be changed once they are sent to the client, would you like to save and proceed?",
					)}
				</div>
			</Modal.Body>
			<Modal.Footer>
				<button
					type="button"
					onClick={onCancel}
					className="btn btn-link"
				>
					{lang.t("Cancel")}
				</button>
				<button
					type="button"
					onClick={onSend}
					className="btn btn-primary"
				>
					{lang.t("Save and Send")}
				</button>
			</Modal.Footer>
		</Modal>
	);
};

SendNonRKPayInvoiceConfirmationModal.propTypes = {
	show: PropTypes.bool,
	onCancel: PropTypes.func,
	onSend: PropTypes.func,
	isEstimate: PropTypes.bool,
};

SendNonRKPayInvoiceConfirmationModal.defaultProps = {
	show: false,
	onCancel: () => {},
	onSend: () => {},
	isEstimate: false,
};

export default SendNonRKPayInvoiceConfirmationModal;
